import { styled } from "@mui/material";

export const InstitutionFormStyled = styled("div")`

    .title {
        font-weight: bold;
        font-size: 20px;
    }

    .add-box {
        margin: 1em auto;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: space-between;

        .success {
            margin-inline: 5px;
        }
    }
`;
